/**
 * Configuration and constants for sticky product sidebar
 */

export const STICKY_STATE = {
	STATIC: 'static',    // Before sticky zone (element at natural position)
	STICKY: 'sticky',    // In sticky zone (element fixed to viewport)
	STOPPED: 'stopped'   // Past stop marker (element pinned at stop position)
};

export const CONFIG = {
	selectors: {
		// Main container with sticky enabled
		container: '.product-single[data-sticky-enabled="true"]',
		// The element that will become sticky
		stickyElement: '.product-single__details',
		// Navigation for offset calculation (legacy, now using CSS variable)
		navigation: 'nav#NavStandard',
		// Marker indicating where sticky should stop
		stopMarker: '[sticky-stop-marker]',
		// Main content container (absolute positioning parent)
		mainContent: '#MainContent',
		// Fallback stop element if no marker found
		footer: '#SiteFooter'
	},
	// Minimum viewport width for sticky behavior
	breakpoint: 768,
	// Spacing below sticky element when stopped
	spacing: {
		withMarker: 0,      // No extra spacing when explicit marker present
		withoutMarker: 60   // Extra spacing when using footer as fallback
	}
};
